/* eslint-disable import/first */
/* (temporary*) fix for Semantic ui css quirk ...
  The Dropdown module from semantic-ui-react also needs collections/menu.less and modules/transition.less as well as globals/reset.less and globals/site.less from semantic-ui-less/definitions/. These "additional" dependencies have to be added manually (also see issue #1).
  - https://github.com/skleeschulte/babel-plugin-transform-semantic-ui-react-imports/issues/1
  - solvable with @alo/semantic-ui-react
*/
import 'semantic-ui-css/components/menu.css';
import 'semantic-ui-css/components/transition.css';
import 'semantic-ui-css/components/dimmer.css'; // just in case it's needed

import '../../styles/theme.scss';

// imported early to speed up/kick off `locationData` promise earlier
import '../utils/location';

// ? [REVISIT] only 'global' things should be here, annything that can be moved to template, long term, should move

// ? [REVISIT] ideally we would kill jquery (even BS 5 doesn't use it), but it's hard to trace everywhere it's used (including js files in assets / if they are in use)
import jQuery from 'jquery';

// ? [REVISIT] how safe is it to override the preloaded version of jquery without our own?
window.$ = jQuery;
//@ts-expect-error
window.jQuery = jQuery;

// ? [REVISIT] deprecate boostrap or find a way to move this code closer to where it's used (section/component)
// Bootstrap
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/carousel';

//@ts-expect-error // ? [REVISIT]
import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
import '../global';
import '../globals';
import '../sections/header/initializeHeaderScripts';
import { IS_NATIVE_APP_CLIENT } from '../utils/helpers';
import { salesforceChatHack } from '../utils/salesforceChatHack';
import { GWPandLoyaltyGeoSettings } from '../globals';
import { checkHasDevServerAccess } from '../passwordLock';
import { renderDesktopNav } from '../sections/header/DesktopNav';
import { SiteSettings } from '../utils/environment';
import { getCurrentCartData } from '../utils/cart/cart-api-utils';

if (SiteSettings?.builderPoweredMenus) renderDesktopNav();

// Common a11y fixes
focusHash();
bindInPageLinks();

if (!IS_NATIVE_APP_CLIENT) {
  import('../templates/_shared/ui-components/LoyaltySuccessModal/initLoyaltySuccessModal').then((module) =>
    module.initLoyaltySuccessModal()
  );
  //@ts-expect-error
  window.salesforceChatHack = salesforceChatHack;
  // password protection
  checkHasDevServerAccess();
}
// ! [REVISIT] add timeout param; crossbrowser support
// window.requestIdleCallback(
import(
  /* webpackChunkName: "themeLazy" */
  './theme/lazy'
);
//   {
//     timeout: 500,
//   }
// );

(async () => {
  await getCurrentCartData();
  const hiddenItems = document.querySelectorAll('#alo-access.hide-loyalty');
  const loyaltySettings = await GWPandLoyaltyGeoSettings();
  const shouldRenderLoyalty =
    loyaltySettings.shouldRenderLoyaltyForDomestic || loyaltySettings.shouldRenderLoyaltyWidgetForINTL;

  if (shouldRenderLoyalty) {
    hiddenItems.forEach((item) => item.classList.remove('hide-loyalty'));
  }
})();
